import { Component, effect, inject, model, input } from '@angular/core';
import { NgSelectComponent } from '@ng-select/ng-select';
import {
  FormGroup,
  FormControl,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';

import { CrudService } from '../../core/services/crud.service';
import { ProductForm } from '../../core/services/crud.interface';
import { removeEmptyValues } from '../../shared/helpers';

import { ModalComponent } from '../../shared/components/modal/modal.component';

@Component({
  selector: 'app-product-form',
  imports: [ReactiveFormsModule, NgSelectComponent, ModalComponent],
  templateUrl: './product-form.component.html',
  styles: ``,
})
export class ProductFormComponent {
  private crudService = inject(CrudService);

  showModal = model(false);
  existingProduct = input();

  categories: Array<any> = [];
  uoms: Array<any> = [];

  confirmationMessage = '';
  errorMessage = '';

  productForm = new FormGroup({
    name: new FormControl('', Validators.required),
    sku: new FormControl('', Validators.required),
    description: new FormControl(''),
    categoryIds: new FormControl(null),
    price_retail: new FormControl(0, [Validators.required, Validators.min(0)]),
    price_wholesale: new FormControl(0, [
      Validators.required,
      Validators.min(0),
    ]),
    price_roll: new FormControl(0, [Validators.required, Validators.min(0)]),
    uom: new FormControl(null, Validators.required),
  });

  buttonText = '';

  constructor() {
    effect(() => {
      if (this.showModal()) {
        this.initializeCombos();

        if (this.existingProduct() !== null) {
          this.buttonText = 'Actualizar';

          const categories = (this.existingProduct() as any)[
            'product_categories'
          ].map((item: any) => item.id);

          this.productForm.patchValue({
            name: (this.existingProduct() as any)['name'],
            sku: (this.existingProduct() as any)['sku'],
            description: (this.existingProduct() as any)['description'],
            categoryIds: categories,
            price_retail: (this.existingProduct() as any)['price_retail'],
            price_wholesale: (this.existingProduct() as any)['price_wholesale'],
            price_roll: (this.existingProduct() as any)['price_roll'],
            uom: (this.existingProduct() as any)['uom_key'],
          });

          // console.log(this.productForm.get('categoryIds')?.value);
        } else {
          this.buttonText = 'Crear';

          this.clearForm();
          this.generateSku();
        }
      }
    });
  }

  initializeCombos() {
    this.crudService.getCategories().subscribe({
      next: (response: any) => {
        if (response.ok) {
          this.categories = response.body;
        }
      },
    });

    this.crudService.getEnum('UnitOfMeasure').subscribe({
      next: (response: any) => {
        if (response.ok) {
          this.uoms = Object.entries(response.body).map(([key, value]) => {
            return { id: key, name: value };
          });
        }
      },
    });
  }

  submit() {
    const cleanProductForm = removeEmptyValues(this.productForm.value);
    this.confirmationMessage = '';
    this.errorMessage = '';

    if (this.existingProduct() != null) {
      this.updateProduct(this.productForm.value as ProductForm);
    } else {
      this.createProduct(cleanProductForm as ProductForm);
    }
  }

  createProduct(cleanProductForm: ProductForm) {
    this.crudService.createProduct(cleanProductForm as ProductForm).subscribe({
      next: (response: any) => {
        if (response.status === 201) {
          this.confirmationMessage = 'Producto añadido';
          this.clearForm();
          this.generateSku();
        }
      },
      error: (error: any) => {
        if (error.status === 409) {
          this.errorMessage = error.error.message;
        } else {
          this.errorMessage = 'Error inesperado. Intente nuevamente.';
        }
        this.clearForm();
      },
    });
  }

  updateProduct(productForm: ProductForm) {
    this.crudService
      .updateProduct((this.existingProduct() as any)['id'], productForm)
      .subscribe({
        next: (response: any) => {
          if (response.ok) {
            this.close();
          }
        },
      });
  }

  cancel() {
    this.close();
  }

  close() {
    this.showModal.set(false);
  }

  generateSku() {
    // if (this.productForm.get('name')?.value) {
    this.productForm.get('sku')?.setValue(`PROD-${Date.now().toString()}`);
    // }
  }

  clearForm() {
    this.productForm.reset({
      name: '',
      sku: '',
      description: '',
      categoryIds: null,
      price_retail: 0,
      price_wholesale: 0,
      price_roll: 0,
      uom: null,
    });
  }
}
